import ContentTypes from "../../../../../lib/html5-software-library/src/ranj/eng/content/ContentTypes";
import MediatorManager from "../../../core/application/MediatorManager";
import SkinFactory from "../../../core/ui/SkinFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import KeyDecision from "../../key-decisions/model/KeyDecision";
import HubKeyDecisionListItemMediator from "../view/HubKeyDecisionListItemMediator";

export default class HubKeyDecisionListItemFactory {
    /**
     * @console
     * @param {MediatorManager} mediatorManager
     */
    constructor(mediatorManager) {
        this._mediatorManager = mediatorManager;
    }

    /**
     * 
     * @param {createjs.Container} container 
     * @param {KeyDecision} keyDecision 
     * @returns {HubKeyDecisionListItemMediator}
     */
    createKeyDecisionListItem(container, keyDecision) {
        const keyDecisionContentType = keyDecision.content.getType();

        let keyDecisionListItemSkin;
        switch (keyDecisionContentType) {
            case ContentTypes.TYPE_EMAIL_DRAFT:
                keyDecisionListItemSkin = new lib.MainAssets.HubKeyDecisionNotification_Mail();
                break;
            case ContentTypes.TYPE_DIALOG:
                keyDecisionListItemSkin = new lib.MainAssets.HubKeyDecisionNotification_Dialog();
                break;
            case ContentTypes.TYPE_DECISION:
                keyDecisionListItemSkin = new lib.MainAssets.HubKeyDecisionNotification_Dialog();
                break;
            default:
                console.error(`[HubKeyDecisionListItemFactory] Unhandled key decision type '${keyDecisionContentType}'.`);
                break;
        }

        keyDecisionListItemSkin.customData = {
            keyDecision,
        };

        container.addChild(keyDecisionListItemSkin);

        const mapMediator = this._mediatorManager.createMediator(keyDecisionListItemSkin, SkinKeyRegistry.HUB_KEY_DECISION_LIST_ITEM_SKIN);
        return mapMediator;
    }
}